import { Chip } from '~/components/elements/Chip'
import { usePopularBrands } from '~/features/shared/brand/hooks/usePopularBrands'
import { buildUrl } from '~/features/shared/search/coordinate/builder/buildUrl'
import { genderToSexId } from '~/lib/gender/converter'
import { Gender } from '~/lib/gender/types'

type Props = {
  gender: Gender
  category: { id: number; name: string; key: string }
  childCategory?: { id: number; name: string; key: string }
}

export const PopularBrandsByCategory: React.FC<Props> = ({
  gender,
  category,
  childCategory,
}) => {
  const { data } = usePopularBrands({
    limit: 8,
    category_id: childCategory?.id,
    type_category_id: category.id,
    sex_id: genderToSexId(gender),
  })

  if (!data) return null
  return (
    <section className="flex flex-col gap-3">
      <h3 className="text-[14px] font-bold leading-[1.4] xl:leading-none">
        {childCategory?.name ?? category.name}を人気のブランドから探す
      </h3>
      <ul className="flex flex-wrap gap-[6px]">
        {data.brands.map((brand) => {
          if (!brand?.key) return null
          return (
            <li key={brand.id}>
              <Chip
                href={buildUrl({
                  snapItems: [
                    {
                      category: {
                        ...category,
                        child: childCategory,
                      },
                      brand: { id: brand.id, key: brand.key, name: brand.name },
                    },
                  ],
                })}
              >
                {brand.name}
              </Chip>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
